import React from 'react';
import {
  ModalHeader,
  ModalBody,
  Modal,
  Text,
  ModalFooter,
  Box,
  Button,
} from '@razorpay/blade/components';

export const ConfirmSaveModal = ({
  isOpen,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalHeader title="Save Office Locations?" />
      <ModalBody>
        <Text color="surface.text.gray.muted">
          Are you sure you want to save office locations? Once saved, you will not be able to edit them.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.5" justifyContent="flex-end">
          <Button variant="tertiary" onClick={onDismiss}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Proceed
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
